module.exports = __webpack_public_path__ + "img/hr-filter-inserter-hand-open.b7bd8490.png";